import { isHertzRent2Buy } from 'site-modules/shared/utils/dealer-details-utils';

const BUY_ONLINE_CTA = 'Buy Online';
const RESERVE_NOW_CTA = 'Reserve Now';

export function getCta(parentDealershipName) {
  if (isHertzRent2Buy(parentDealershipName)) {
    return RESERVE_NOW_CTA;
  }
  return BUY_ONLINE_CTA;
}
